import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, computed } from '@angular/core';
import { LayoutService } from '../../services/LayoutService';
import { RegistryService } from '../../services/RegistryService';
import './billing-settings-component/billing-settings-page.js';

export interface BillingSettingsDetail {
  activePlans: string[];
  activeCount: number;
  pricePerPlan: number;
  total: number;
  currency: string;
  nextBillingDate: string;
  status: string;
  theme: string;
  resolvedTheme: string;
}

@Component({
  selector: 'app-billing',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
  template: `
    <billing-settings-page
      [attr.theme]="layout.theme()"
      [activePlans]="activePlans()"
      (paymentmethodrequest)="openPaymentPage($event)"
      (planchange)="onPlanChange($event)">
    </billing-settings-page>
  `,
  styles: [`
    billing-settings-page {
      display: block;
    }
  `]
})
export class BillingComponent {
  public layout = inject(LayoutService);
  private registry = inject(RegistryService);

  public activePlans = computed(() => {
    const services = this.registry.services();
    const plans: string[] = [];
    if (services.some(s => s.name === 'lite_schedule')) {
      plans.push('lite_schedule');
    }
    if (services.some(s => s.name === 'tasks')) {
      plans.push('tasks');
    }
    return plans;
  });

  openPaymentPage(e: Event) {
    const customEvent = e as CustomEvent<BillingSettingsDetail>;
    console.log(customEvent.detail);

    const plans = customEvent.detail.activePlans || [];
    const hasLiteSchedule = plans.includes('lite_schedule');
    const hasTasks = plans.includes('tasks');

    let url = '';
    if (hasLiteSchedule && hasTasks) {
      // Case 1: ["lite_schedule", "tasks"]
      url = 'https://pay.grow.link/MTAwODUy~2c8c92c883ee2f187e83e1755ed6e0fd-MzQ0ODExNA';
    } else if (hasLiteSchedule) {
      // Case 2: ["lite_schedule"]
      url = 'https://pay.grow.link/MTAwODUy~19b322d1d3cf0726871c8697d1a4d8df-MzQ0ODg4OQ';
    } else if (hasTasks) {
      // Case 3: ["tasks"]
      url = 'https://pay.grow.link/MTAwODUy~fc0ce78e46da1faa75825d14b3d6d0b3-MzQ0OTI0NQ';
    } else {
      // Fallback url
      url = 'https://pay.grow.link/MTAwODUy~2c8c92c883ee2f187e83e1755ed6e0fd-MzQ0ODExNA';
    }

    const windowFeatures = 'noopener,noreferrer,width=1000,height=800,scrollbars=yes,resizable=yes';
    window.open(url, '_blank', windowFeatures);
  }

  onPlanChange(event: Event) {
    const customEvent = event as CustomEvent;
    console.log('Billing plans changed:', customEvent.detail);
  }
}

